import { render, staticRenderFns } from "./kick-run-view.vue?vue&type=template&id=b10f095e"
import script from "./kick-run-view.vue?vue&type=script&lang=js"
export * from "./kick-run-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports